/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'Bot'>;
const hooks = useModelQueries(schema, 'Bot');

export const useAggregateBot: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountBot: Hooks['useCount'] = hooks.useCount;
export const useCreateBot: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyBot: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnBot: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteBot: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyBot: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsBot: Hooks['useExists'] = hooks.useExists;
export const useFindFirstBot: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyBot: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueBot: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByBot: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyBot: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateBot: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountBot: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstBot: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyBot: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueBot: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByBot: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyBot: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateBot: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyBot: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnBot: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertBot: Hooks['useUpsert'] = hooks.useUpsert;
